import { reactive } from "vue";
import { toast } from "vue-sonner";
import i18n from "@/shared/config/i18n";

// Re-export toast for direct usage in components:
// toast("Default message")
// toast.success("Done!")
// toast.error("Failed")
// toast.warning("Watch out")
// toast.info("FYI")
// toast.promise(asyncFn, { loading, success, error })
export { toast };

export const alertStore = reactive({
  message: "",
  description: "",
  type: "error",
  visible: false,
});

const sonnerTypeMap = {
  success: "success",
  error: "error",
  warning: "warning",
  info: "info",
};

export function showAlert(message, description, type = "error") {
  const method = sonnerTypeMap[type] || "error";
  toast[method](message, {
    description: description || undefined,
    duration: 3000,
    action: {
      label: i18n.global.t("Закрыть все"),
      onClick: () => toast.dismiss(),
    },
  });
}
